import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";

const NOT_FOUND = { title: "Document Not Found", body: "This document isn't available yet." };

export default function LegalPage() {
  const { doc } = useParams();
  const [content, setContent] = useState(null);

  useEffect(() => {
    setContent(null);
    api
      .get(`/content/legal/${doc}`)
      .then(({ data }) => setContent(data))
      .catch(() => setContent(NOT_FOUND));
  }, [doc]);

  if (!content) return null;

  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 py-20" data-testid="legal-page">
      <h1 className="font-extrabold uppercase text-2xl sm:text-3xl tracking-tight mb-6">{content.title}</h1>
      <p className="text-midnight-black/75 font-medium leading-relaxed">{content.body}</p>
    </div>
  );
}
